import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useLocation } from 'react-router-dom';

import { cn } from '@/lib/utils';

export function AlertsBell(): import('react/jsx-runtime').JSX.Element {
  const { pathname } = useLocation();
  const [unacked, setUnacked] = useState(0);

  useEffect((): void => {
    fetch('/api/orgs/active/alert-events')
      .then((r): Promise<{ acknowledged_at: string | null }[]> | never[] =>
        r.ok ? (r.json() as Promise<{ acknowledged_at: string | null }[]>) : [],
      )
      .then((events: { acknowledged_at: string | null }[]): void => {
        setUnacked(events.filter((e): boolean => e.acknowledged_at == null).length);
      })
      .catch((): void => {});
  }, [pathname]); // re-check when navigating away from /alerts

  return (
    <Link
      to="/alerts"
      className={cn(
        'relative rounded-full h-7 w-7 flex items-center justify-center transition-colors',
        pathname === '/alerts'
          ? 'bg-accent text-accent-foreground'
          : 'text-muted-foreground hover:text-foreground',
      )}
      title="Alerts"
    >
      <Bell className="h-4 w-4" />
      {unacked > 0 && (
        <span className="absolute top-0 right-0 h-2 w-2 rounded-full bg-destructive ring-1 ring-background" />
      )}
    </Link>
  );
}
